import { useQuery } from 'react-query';

import { queries } from '~/constants/queryKeys';
import { dispatchError } from '~/containers/ErrorContainer/errorEventListener';
import { SentryHelper } from '~/helpers/Sentry/SentryHelper';
import { VinovestNetworkingHelper } from '~/helpers/VinovestNetworkingHelper';
import { useAuthentication } from '~/hooks/useAuthentication';
import { GetUniqueWireResponse } from '~/networking';

/** Returns wire information for a specific user and their portfolio */
export const useGetWireInformation = (portfolioId?: string) => {
    const { isAuthenticated } = useAuthentication();

    return useQuery(
        [queries.getPortfolioBankWireInformation, portfolioId],

        async (): Promise<GetUniqueWireResponse | undefined> => {
            try {
                const { managed } = VinovestNetworkingHelper.getClient();
                const result = await managed.getUniqueWireInformation(portfolioId || '');
                if (result) {
                    return result.data;
                }
                return undefined;
            } catch (error) {
                SentryHelper.captureException(error);
                dispatchError(error);
            }
            return undefined;
        },
        {
            enabled: isAuthenticated && !!portfolioId
        }
    );
};
